// extracted by mini-css-extract-plugin
export default {"wrapper":"oc","star":"pc","emptyStar":"qc","filledStar":"rc","filledStarSvg":"sc"};